import styles from "./api-keys-table.module.scss";

export const apiKeysTableClasses = {
  store: styles.storeColumn,
  apiKey: styles.apiKeyColumn,
  actions: styles.actionsColumn,
};
